
const digest = '368d135007888b314104de0570b54ab696f9e2d54955fa19ea2ea0bf15f005ad';
const classes = {"linkButton":"_linkButton_1hezn_1","wizardButton":"_wizardButton_1hezn_8"};
const css = `._linkButton_1hezn_1 {
  color: #3c3f9c;
  text-decoration: underline;
  font-size: 14px;
  cursor: pointer;
}

._wizardButton_1hezn_8 {
  position: relative;
  text-decoration: none;
  background-color: #fff;
  padding: 13px 14px;
  display: flex;
  flex-direction: row;
  border-radius: 15px;
  align-items: center;
  box-shadow: -3px 7px 13px 0 rgba(68, 70, 105, 0.15);
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  